import { api } from "@api/api";
import { ApiResponse } from "@shared/types";
import { PlanMapOption } from "@modules/erpIntegrations/types";

import { ListPlanMapOptionsQueryFilters } from "./types";

export async function getPlanMapOptionsService(
  filters: ListPlanMapOptionsQueryFilters
): Promise<PlanMapOption[]> {
  const { data } = await api.get<ApiResponse<PlanMapOption>>(
    "/v1/integration_plan_map_option_admin/",
    {
      params: {
        integration: filters.integration,
        page: filters.page,
        page_size: filters.perPage ?? 100,
      },
    }
  );

  return data.results;
}

export async function countPlanMapOptionsByEndpoint(endpointId: number): Promise<number> {
  const { data } = await api.get<ApiResponse<PlanMapOption>>(
    "/v1/integration_plan_map_option_admin/",
    { params: { endpoint: endpointId, page_size: 1 } }
  );

  return data.count ?? 0;
}
